<template>
  <div id="app">
    <transition name="fade"
		            mode="out-in">
			<router-view></router-view>
		</transition>
  </div>
</template>

<style lang='scss'>

</style>

<script>

export default {
  
}
</script>
